function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import { useContext } from "react";
import { useBuildStyleWithTheme } from "../../ThemeProvider/useBuildStyleWithTheme";
import { CarinaContext } from "../../CarinaProvider";
var buildStyle = function(param) {
    var animation = param.animation, font = param.font;
    var _easeIn = animation.expressive.easeIn, _duration = _easeIn.duration, duration = _duration.fast, easing = _easeIn.easing;
    return {
        iconColor: font.color.soft,
        icon: {
            base: {
                display: 'inline-block',
                transitionProperty: 'transform',
                transitionDuration: duration,
                transitionTimingFunction: easing,
                transitionDelay: animation.duration[100]
            },
            chevronDown: {
                transform: 'rotate(-180deg)',
                transitionDelay: '0s'
            },
            chevronRight: {
                transform: 'rotate(90deg)',
                transitionDelay: '0s'
            },
            chevronLeft: {
                transform: 'rotate(90deg)',
                transitionDelay: '0s'
            },
            reducedMotion: {
                transitionProperty: 'none'
            }
        }
    };
};
export var useStyle = function(isOpen) {
    var ref;
    var prefersReducedMotion = ((ref = useContext(CarinaContext)) !== null && ref !== void 0 ? ref : {
        prefersReducedMotion: false
    }).prefersReducedMotion;
    var builtStyle = useBuildStyleWithTheme(buildStyle);
    if (!builtStyle) {
        return {
            iconColor: undefined,
            chevronDown: {},
            chevronRight: {},
            chevronLeft: {}
        };
    }
    var iconColor = builtStyle.iconColor, icon = builtStyle.icon;
    return {
        iconColor: iconColor,
        chevronDown: _objectSpread({}, icon.base, prefersReducedMotion && icon.reducedMotion, isOpen ? _objectSpread({}, icon.chevronDown) : {}),
        chevronRight: _objectSpread({}, icon.base, prefersReducedMotion && icon.reducedMotion, isOpen ? _objectSpread({}, icon.chevronRight) : {}),
        chevronLeft: _objectSpread({}, icon.base, prefersReducedMotion && icon.reducedMotion, isOpen ? _objectSpread({}, icon.chevronLeft) : {})
    };
};
